import React, { useState } from "react";
import { Helmet } from "react-helmet";

export default function EmergencyResources() {
  const [openCategory, setOpenCategory] = useState(null);

  const resourceCategories = [
    {
      id: "domestic-abuse",
      title: "Domestic Abuse Support",
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      gradientStyle: "linear-gradient(to bottom right, #fb7185, #ec4899)",
      description: "24/7 confidential support for those experiencing domestic violence",
      resources: [
        {
          name: "National Domestic Violence Hotline",
          phone: "(800) 799-7233",
          details: ["Available 24/7", "Confidential support", "Crisis intervention"],
          urgent: true,
        },
        {
          name: "Texarkana Domestic Violence Prevention",
          phone: "(903) 793-4357",
          details: ["Local support services", "Emergency shelter", "Counseling available"],
        },
      ],
    },
    {
      id: "addiction",
      title: "Addiction Rehabilitation",
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      gradientStyle: "linear-gradient(to bottom right, #c084fc, #6366f1)",
      description: "Recovery programs and support groups in the Texarkana area",
      resources: [
        {
          name: "RU Recovery Program",
          location: "Northern Hills Baptist Church",
          schedule: "Fridays 7:00 P.M. - Conference Room",
          phone: "(870) 773-3580",
        },
        {
          name: "Celebrate Recovery (COTR)",
          location: "Church On The Rock",
          schedule: "Fridays 5:30 P.M. - Connect Cafe",
          phone: "(903) 701-9553",
        },
        {
          name: "Celebrate Recovery (First Baptist Moores Lane)",
          location: "First Baptist Moores Lane",
          schedule: "Tuesdays 6:00 P.M. - Fusion Center",
          phone: "(903) 831-6000",
          details: [
            "Call ahead if childcare is needed",
            "Addiction recovery for men and women struggling with all kinds of addictions",
            "Support for family members dealing with a loved one's addiction and codependency issues",
            "Emotional healing groups for those struggling with past hurt and abuse",
            "The Landing: Faith-based program for teens struggling with addiction, eating disorders, or family struggles",
          ],
        },
      ],
    },
    {
      id: "food",
      title: "Food Assistance",
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      gradientStyle: "linear-gradient(to bottom right, #fbbf24, #f97316)",
      description: "Emergency food banks and pantry services",
      resources: [
        {
          name: "Harvest Regional Food Bank",
          phone: "(870) 774-1398",
          website: "https://harvestregionalfoodbank.org/food-assistance/",
          details: ["Multiple distribution sites", "Food assistance programs"],
        },
        {
          name: "Church On The Rock Food Pantry",
          phone: "(903) 794-8589",
          location: "2301 University Ave. Texarkana, TX",
          schedule: "Tuesday - Friday 9am - 5pm",
          details: ["Closed 12-1pm for lunch", "Office door side of building - ring doorbell"],
        },
      ],
    },
    {
      id: "shelter",
      title: "Shelter & Life Skills",
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      gradientStyle: "linear-gradient(to bottom right, #34d399, #14b8a6)",
      description: "Emergency shelter, meals, and life skills programs",
      resources: [
        {
          name: "Randy Sams Outreach Shelter",
          phone: "(903) 792-7024",
          location: "402 Oak Street, Texarkana, TX 75501",
          details: ["Emergency shelter", "Meals provided", "Life skills classes"],
        },
      ],
    },
    {
      id: "trafficking",
      title: "Sex Trafficking Resources",
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      ),
      gradientStyle: "linear-gradient(to bottom right, #f87171, #f43f5e)",
      description: "This crime occurs when a trafficker uses force, fraud or coercion to control another person for commercial sex acts. Anyone selling sex who is under 18 is legally a trafficking victim.",
      urgent: true,
      resources: [
        {
          name: "National Human Trafficking Hotline",
          phone: "(888) 373-7888",
          details: ["24/7 confidential support", "Available in 200+ languages", "Crisis intervention and referrals"],
          urgent: true,
        },
        {
          name: "Polaris Project",
          phone: "(202) 790-6300",
          website: "https://polarisproject.org/sex-trafficking/",
          details: ["Resources and education", "Survivor support"],
        },
        {
          name: "Elijah's House",
          phone: "(903) 949-6733",
          website: "https://www.neldashaversministries.org/blank-1",
          details: ["Local safe housing", "Recovery programs"],
        },
      ],
    },
  ];

  return (
    <div className="font-nunito">
      <Helmet>
        <link rel="icon" href="favicon.ico" />
        <title>Emergency Resources | Pathway Resource Center</title>
        <meta
          name="description"
          content="Discover resources in your area to help with food, shelter, or rehabilitation."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#457B9D] via-[#5a8fb0] to-[#457B9D] py-20">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute left-0 top-0 h-96 w-96 rounded-full bg-white blur-3xl"></div>
          <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-white blur-3xl"></div>
        </div>

        <div className="relative mx-auto max-w-5xl px-6">
          <div className="text-center">
            <div className="mb-6 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 rounded-full bg-white opacity-20 blur-2xl"></div>
                <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                  <svg className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
              </div>
            </div>

            <h1 className="mb-6 text-4xl font-bold leading-tight text-white md:text-5xl lg:text-6xl">
              Help is Available
            </h1>
            <p className="mx-auto mb-8 max-w-3xl text-lg leading-relaxed text-blue-100 md:text-xl">
              If you or someone you know is facing a crisis, you don't have to go through it alone. Below you'll find local and national resources for emergency support.
            </p>

            {/* Emergency Banner */}
            <div className="mx-auto max-w-2xl rounded-2xl bg-white/10 p-6 backdrop-blur-sm">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-500">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                </div>
                <div className="text-left">
                  <h3 className="mb-2 text-xl font-semibold text-white">In Immediate Danger?</h3>
                  <p className="text-blue-100">If you are in immediate danger, please call 911 or go to your nearest emergency room.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Wave Divider */}
        <div className="absolute bottom-0 left-0 w-full">
          <svg viewBox="0 0 1440 120" className="w-full" preserveAspectRatio="none" style={{ height: '80px' }}>
            <path d="M0,64 C360,120 720,0 1440,64 L1440,120 L0,120 Z" fill="white" opacity="0.3" />
            <path d="M0,80 C360,20 720,100 1440,80 L1440,120 L0,120 Z" fill="white" />
          </svg>
        </div>
      </section>

      {/* Resources Section */}
      <section className="bg-gradient-to-b from-white via-blue-50/30 to-white py-16">
        <div className="mx-auto max-w-6xl px-6">
          <div className="mb-12 text-center">
            <div className="mb-4 inline-block rounded-full bg-[#457B9D]/10 px-6 py-2">
              <span className="text-sm font-semibold uppercase tracking-wide text-[#457B9D]">
                Support Resources
              </span>
            </div>
            <h2 className="mb-4 text-3xl font-bold text-gray-800 md:text-4xl">
              Find the Help You Need
            </h2>
            <p className="mx-auto max-w-2xl text-lg text-gray-600">
              Select a category below to view available resources and contact information
            </p>
          </div>

          {/* Resource Categories Grid */}
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {resourceCategories.map((category, index) => (
              <div
                key={category.id}
                className="group"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
                }}
              >
                <div className={`relative overflow-hidden rounded-2xl bg-white shadow-lg transition-all duration-300 hover:shadow-xl ${openCategory === category.id ? 'ring-2 ring-[#457B9D]' : ''}`}>
                  {/* Card Header - Clickable */}
                  <button
                    onClick={() => setOpenCategory(openCategory === category.id ? null : category.id)}
                    className="w-full p-6 text-left"
                  >
                    {/* Urgent Badge */}
                    {category.urgent && (
                      <div className="absolute right-4 top-4">
                        <span className="rounded-full bg-red-500 px-3 py-1 text-xs font-semibold text-white">
                          24/7
                        </span>
                      </div>
                    )}

                    {/* Icon */}
                    <div
                      className="mb-4 inline-flex rounded-full p-3 text-white"
                      style={{ background: category.gradientStyle }}
                    >
                      {category.icon}
                    </div>

                    {/* Title */}
                    <h3 className="mb-3 text-xl font-semibold text-gray-800">
                      {category.title}
                    </h3>

                    {/* Description */}
                    <p className="mb-4 text-sm leading-relaxed text-gray-600">
                      {category.description}
                    </p>

                    {/* Expand Indicator */}
                    <div className="flex items-center gap-2 text-sm font-medium text-[#457B9D]">
                      <span>{openCategory === category.id ? 'Hide' : 'View'} Resources</span>
                      <svg
                        className={`h-4 w-4 transition-transform duration-300 ${openCategory === category.id ? 'rotate-180' : ''}`}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </button>

                  {/* Expanded Content - Inside same card */}
                  {openCategory === category.id && (
                    <div
                      className="border-t border-gray-100 bg-gray-50/50 px-6 pb-6"
                      style={{
                        animation: 'slideDown 0.3s ease-out',
                      }}
                    >
                      <div className="space-y-4 pt-4">
                        {category.resources.map((resource, idx) => (
                          <div
                            key={idx}
                            className={`rounded-xl border p-4 transition-all duration-300 hover:shadow-md ${resource.urgent ? 'border-red-200 bg-red-50' : 'border-gray-200 bg-white'}`}
                          >
                            {/* Resource Name */}
                            <h4 className={`mb-2 font-semibold ${resource.urgent ? 'text-red-700' : 'text-gray-800'}`}>
                              {resource.name}
                            </h4>

                            {/* Contact Info */}
                            <div className="space-y-1.5 text-sm">
                              {resource.phone && (
                                <a
                                  href={`tel:${resource.phone.replace(/\D/g, '')}`}
                                  className="flex items-center gap-2 text-[#457B9D] transition-colors hover:text-[#365f7a]"
                                >
                                  <svg className="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                  </svg>
                                  <span className="font-medium">{resource.phone}</span>
                                </a>
                              )}

                              {resource.location && (
                                <div className="flex items-start gap-2 text-gray-600">
                                  <svg className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                  </svg>
                                  <span>{resource.location}</span>
                                </div>
                              )}

                              {resource.schedule && (
                                <div className="flex items-start gap-2 text-gray-600">
                                  <svg className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                  </svg>
                                  <span>{resource.schedule}</span>
                                </div>
                              )}

                              {resource.website && (
                                <a
                                  href={resource.website}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="flex items-center gap-2 text-[#457B9D] transition-colors hover:text-[#365f7a]"
                                >
                                  <svg className="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                                  </svg>
                                  <span className="font-medium">Visit Website</span>
                                </a>
                              )}
                            </div>

                            {/* Additional Details */}
                            {resource.details && resource.details.length > 0 && (
                              <div className="mt-3 border-t border-gray-100 pt-3">
                                <ul className="space-y-1">
                                  {resource.details.map((detail, detailIdx) => (
                                    <li key={detailIdx} className="flex items-start gap-2 text-xs text-gray-600">
                                      <svg className="mt-0.5 h-3 w-3 flex-shrink-0 text-[#457B9D]" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                      </svg>
                                      <span>{detail}</span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Support Banner */}
      <section className="bg-gradient-to-r from-blue-50 via-white to-pink-50 py-16">
        <div className="mx-auto max-w-4xl px-6 text-center">
          <div className="mb-8 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 rounded-full bg-[#457B9D] opacity-20 blur-2xl"></div>
              <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#457B9D] to-[#5a8dad]">
                <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
            </div>
          </div>

          <h2 className="mb-4 text-3xl font-bold text-gray-800 md:text-4xl">
            We're Here for You Too
          </h2>
          <p className="mb-8 text-lg leading-relaxed text-gray-600">
            At Pathway Resource Center, we offer pregnancy support, counseling, and resources to help you through life's challenges. You don't have to face this alone.
          </p>

          <div className="flex flex-col gap-4 sm:flex-row sm:justify-center">
            <a
              href="/contact"
              className="group relative overflow-hidden rounded-full bg-gradient-to-r from-[#457B9D] to-[#5a8dad] px-8 py-4 font-semibold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                Contact Pathway
                <svg className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </a>

            <a
              href="tel:+18707792229"
              className="flex items-center justify-center gap-2 rounded-full border-2 border-[#457B9D]/30 bg-white px-8 py-4 font-semibold text-[#457B9D] transition-all duration-300 hover:border-[#457B9D] hover:bg-blue-50"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Call 870-779-2229
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <svg className="h-5 w-5 text-[#457B9D]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Confidential</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="h-5 w-5 text-[#457B9D]" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
              </svg>
              <span>Free Services</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="h-5 w-5 text-[#457B9D]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
              </svg>
              <span>Caring Support</span>
            </div>
          </div>
        </div>
      </section>

      {/* Add animation keyframes */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
